const useDinamicPageTitle = (title) => {
  document.title = title
}

export { useDinamicPageTitle };